export const trimLeadingZeros = (value: unknown): string => {
  if (value == null || (typeof value !== 'string' && typeof value !== 'number')) return '';
  const str = String(value);

  if (str.startsWith('.')) return trimLeadingZeros(`0${str}`);

  const [integerPart = '0', decimalPart = ''] = str.split('.');

  const trimmedInteger = integerPart.replace(/^0+(?=\d)/, '');

  if (!decimalPart || /^0+$/.test(decimalPart)) return trimmedInteger;

  const trimmedDecimal = decimalPart.replace(/0+$/, '');
  return trimmedDecimal ? `${trimmedInteger}.${trimmedDecimal}` : trimmedInteger;
};
